module.exports = __webpack_public_path__ + "img/conciencia.ed594de0.png";